import { useLocation } from "react-router";
import { WebNavigateParam, LocationSmartWebViewHeader } from "@nxplatform/helpers/helpers";
const useQuery = () => new URLSearchParams(useLocation().search);
const getQueryParam = () => new URLSearchParams(window.location.search);
const excludeLocationDeviceHeader = () => {
  const urlParam = new URLSearchParams(window.location.search);
  const header = urlParam.get(LocationSmartWebViewHeader);
  return {
    header
  };
};
const useWebNavigate = () => {
  const urlParam = new URLSearchParams(window.location.search);
  return {
    isWebNavigate: urlParam.get(WebNavigateParam) === "true"
  };
};
const webViewStatus = () => window.webViewEnabled;
const imbaWebViewStatus = () => window.imbaWebViewEnabled;
export {
  excludeLocationDeviceHeader,
  getQueryParam,
  imbaWebViewStatus,
  useQuery,
  useWebNavigate,
  webViewStatus
};
